import { PaginationOptions } from ".yalc/lib.common/dist/types";
import { ProductoDsTiendaDtSourceImpl } from "../../data/dataSources/ProductoDsTiendaDtSourceImpl";
import { ProductoDsTiendaRepositoryImpl } from "../../data/repositories/ProductoDsTiendaRepositoryImpl";
import { toast } from "lib.front";
import { GetAllProductosDsTiendaUseCase } from "../../business/useCases/GetAllProductosDsTiendaUseCase";

export const useProductoDsTienda = () => {
    const dataSource = new ProductoDsTiendaDtSourceImpl();
    const productoRepository = new ProductoDsTiendaRepositoryImpl(dataSource);
    const getAllProductosDsTienda = async (pagination?: PaginationOptions, selectList?: string[], onlyDen?: boolean) => {
        const getAllProductoUseCase = new GetAllProductosDsTiendaUseCase(productoRepository);
        try {
            const recurso = await getAllProductoUseCase.call(pagination, selectList, onlyDen);
            if (recurso.isError()) {
                toast.showError(recurso.toString());
                return undefined;
            }
            return recurso.data;
        } catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            toast.showError(message);
            return undefined;
        }
    };
    return { getAllProductosDsTienda }
}